import { render, staticRenderFns } from "./DeviceTab.vue?vue&type=template&id=5a3b2efa&scoped=true"
import script from "./DeviceTab.vue?vue&type=script&lang=ts"
export * from "./DeviceTab.vue?vue&type=script&lang=ts"
import style0 from "./DeviceTab.vue?vue&type=style&index=0&id=5a3b2efa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b2efa",
  null
  
)

export default component.exports